import { render, staticRenderFns } from "./_domainSetup.vue?vue&type=template&id=1254af10&lang=pug"
import script from "./_domainSetup.vue?vue&type=script&lang=js"
export * from "./_domainSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports